<template>
  <div>
    <template v-for="channel in channels">
      <v-btn
        :key="`channel_${channel}`"
        depressed
        :outline="value != channel"
        :color="value == channel ? 'primary' : 'grey'"
        @click="onchange(channel)"
        class="ma-0 mr-1 mb-1"
        >{{ $t(channel) }}</v-btn
      >
    </template>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      channels: ['all', 'facebook', 'line']
    }
  },
  filters: {
    capitalize(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    }
  },
  methods: {
    capitalize(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    },
    onchange(value) {
      this.$emit('input', value)
      this.$emit('changeChannel', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/SelectChannel.vue